// extracted by mini-css-extract-plugin
export default {"head":"SectionHead_head__Fa+r4","center":"SectionHead_center__IoOKP","mask":"SectionHead_mask__pJ0TQ","word":"SectionHead_word__q0fUW","dark":"SectionHead_dark__uEvzf"};